/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.benefits.modals.add.controllers', [
  'ui.bootstrap',
  'acme.common.directive.fieldFocus'
])

.controller('MembershipBenefitsModalsAddController', ['$scope', '$uibModalInstance', 'editable', 'currentBenefits', function($scope, $uibModalInstance, editable, currentBenefits) {

    $scope.membershipBenefitsModalsAdd = {

      model: currentBenefits || [],
      benefit: '',
      editIndex: -1,
      editValue: '',
      editable: false,
      enableSort: true,
      sortableOptions: {
        axis: 'y'
      },

      init: function() {
        this.editable = (editable);
        this.enableSort = (editable && this.model.length > 1);
      },

      add: function() {
        if (this.benefit && $.trim(this.benefit).length) {
          this.model.push({ description: angular.copy(this.benefit) });
          this.benefit = '';
        }
      },

      remove: function(index) {
        this.model.splice(index, 1);
      },

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      edit: function(index) {
        if (editable) {
          this.editIndex = index;
          this.editValue = angular.copy(this.model[index]);
        }
      },

      isSortable: function(index) {
        return (editable && this.model.length > 1);
      },

      isEditing: function(index) {
        return (this.editIndex === index);
      },

      closeEdit: function() {
        if (this.model[this.editIndex].description.length) {
          this.editIndex = -1;
        }else{
          this.remove(this.editIndex);
          this.editIndex = -1;
        }
      },

      cancelEdit: function(index) {
        this.editIndex = -1;
        this.model[index] = angular.copy(this.editValue);
      },

      onEditKeyDown: function(e, index) {
        var self = $scope.membershipBenefitsModalsAdd;

        e.stopPropagation();

        if (e.keyCode === 13) {
          self.closeEdit();
        }else if (e.keyCode === 27) {
          self.cancelEdit(index);
        }
      },

      onAddKeyDown: function(e, index) {
        var self = $scope.membershipBenefitsModalsAdd;

        e.stopPropagation();

        if (e.keyCode === 13) {
          self.add();
        }
      },

      done: function() {
        $uibModalInstance.close(this.model);
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipBenefitsModalsAdd.init();

}]);